import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Library from "@/pages/Library";
import Player from "@/pages/Player";
import Feed from "@/pages/Feed";
import { Toaster } from "@/components/ui/sonner";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/feed" element={<Feed />} />
            {/* Player is open: public songs can be viewed by anyone */}
            <Route path="/song/:id" element={<Player />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Library />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/feed" replace />} />
          </Routes>
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#0F0F0F",
                color: "#fff",
                border: "1px solid rgba(255,255,255,0.1)",
                borderRadius: "2px",
                fontFamily: "Outfit, sans-serif",
              },
            }}
          />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
